// export const isShowSnackbar = (state) => state.logbook.snackbarShow;
export const eventsLoadingSelector = (state) => state.events.loading;
export const eventsSelector = (state) => state.events.events;
